// extracted by mini-css-extract-plugin
export default {"mainBlock":"FAQPage_mainBlock__q+nvH","footer":"FAQPage_footer__5Rh91"};